/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { IStatusOption } from './filters.interface';

export const STATUS_OPTIONS: IStatusOption[] = [
  { value: 'Active', label: $localize`:@@S_ACTIVE:Active` },
  { value: 'Planned', label: $localize`:@@S_LIVEMAP_PLANNED:Planned` },
  { value: 'Expired', label: $localize`:@@S_LIVEMAP_EXPIRED:Expired` }
];
